<template>
  <div>
    <div class="font-medium text-xs text-left leading-snug p-4 overflow-auto max-h-[40vh] bg-charcoal-100 dark:bg-dark-950 space-y-4">
      <div class="min-h-24 bg-charcoal-100 dark:bg-dark-800 rounded-lg relative">
        <div class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
          <IconBase name="cute/spinner" class="spin text-charcoal-400" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  onEnd: () => Promise<boolean>
}>()

const emit = defineEmits<{
  (e: 'next'): void
}>()

onMounted(async () => {
  const result = await props.onEnd()
  if (result) emit('next')
})

</script>